const HARD_DISCONNECT_REASON_PATTERNS = [
  "manual_leave",
  "rejoin_timeout",
  "multi_tab_disconnect",
  "permission_denied",
  "permission_denied_retry",
  "permission_denied_home",
  "media_timeout",
  "media_permission",
  "ot_user_media_access_denied",
  "ot_permission_denied",
  "ot_get_user_media_error",
  "ot_no_media_devices",
  "ot_hardware_unavailable",
  "ot_no_media",
  "hard_end",
  "leave",
  "ended",
  "rejoin_failed",
  "call_crash",
  "serverclosed",
  "cancelled",
  "canceled",
  "client_cancel",
  "reject",
];

export function isHardCallDisconnectReason(reason) {
  const normalized = String(reason || "").toLowerCase();
  if (!normalized) return false;
  return HARD_DISCONNECT_REASON_PATTERNS.some((pattern) => normalized.includes(pattern));
}

export function isSoftCallDisconnectReason(reason) {
  return !isHardCallDisconnectReason(reason);
}
